import { type TAudioPaginated as TApiAudioPaginated } from '@core/api'

import { type TAudioPaginated } from '@core/models'

import { convertAudioSimple } from './convertAudioSimple'
import { convertPagination } from './convertPagination'

export const convertAudioPaginated = (apiAudioPaginated: TApiAudioPaginated): TAudioPaginated => {
    const { items: apiItems, pagination } = apiAudioPaginated

    return {
        items: apiItems.map(convertAudioSimple),
        pagination: convertPagination(pagination),
    }
}
